import React from 'react';
import PropTypes from 'prop-types';
import { Box, Markdown } from '@honda-canada/design-system-react';
import { getGtmTagValue } from '../../utils/gtmEvents';
import CTA from '../CTA';
import themeStyles from './TableStyle.styles';

const CellWrapper = themeStyles.apply(Box, 'CellWrapper');

const CellWithCTA = ({ label, ctaType, ctaLink, gtmInfo, componentName }) => (
  <CellWrapper>
    <Markdown>{label}</Markdown>
    {ctaLink?.value?.href && (
        <CTA
          linkField={ctaLink}
          typeField={ctaType}
          gtmTags={{
            'data-gtm-model': getGtmTagValue(gtmInfo?.gtmModelName),
            'data-gtm-trim': getGtmTagValue(gtmInfo?.gtmTrimName),
            'data-gtm-body-style': getGtmTagValue(gtmInfo?.gtmBodyStyle),
            'data-gtm-interaction-type': getGtmTagValue(gtmInfo?.gtmInteractionType),
            'data-gtm-title': getGtmTagValue(gtmInfo?.gtmTitle),
            'data-gtm-label': getGtmTagValue(ctaLink?.value?.text),
            'data-gtm-component-type': getGtmTagValue(componentName),
          }}
        >
          {ctaLink?.value?.text}
        </CTA>
    )}
      </CellWrapper>
);

CellWithCTA.propTypes = {
  label: PropTypes.string,
  ctaLink: PropTypes.string,
  gtmInfo: PropTypes.shape({
    gtmModelName: PropTypes.string,
    gtmTrimName: PropTypes.string,
    gtmBodyStyle: PropTypes.string,
    gtmInteractionType: PropTypes.string,
    gtmTitle: PropTypes.string,
  }),
};

export default CellWithCTA;
